var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "fill-height"
  }, [_c('v-row', {
    staticClass: "ma-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('span', {
    staticClass: "text-h6"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.invoice.title")) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "1"
    }
  }, [!_vm.report.costCenter ? _c('v-btn', {
    attrs: {
      "text": "",
      "small": ""
    },
    on: {
      "click": function click($event) {
        _vm.isCostCenterDialogOpen = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("objects.vehicle.costCenter")) + " ")]) : _c('v-hover', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var hover = _ref.hover;
        return [_c('m-text-field', {
          attrs: {
            "label": _vm.$t('objects.vehicle.costCenter'),
            "dense": "",
            "readonly": "",
            "hide-details": "",
            "reverse": !_vm.isMobile,
            "append-icon": hover ? 'mdi-pencil' : ''
          },
          on: {
            "click:append": function clickAppend($event) {
              _vm.isCostCenterDialogOpen = true;
            }
          },
          model: {
            value: _vm.report.costCenter,
            callback: function callback($$v) {
              _vm.$set(_vm.report, "costCenter", $$v);
            },
            expression: "report.costCenter"
          }
        })];
      }
    }])
  }), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('objects.vehicle.costCenter'),
      "isDialogActive": _vm.isCostCenterDialogOpen,
      "hideLeft": true,
      "rightLoading": _vm.isReportLoading,
      "rightText": _vm.$t('save')
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isCostCenterDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isCostCenterDialogOpen = $event;
      },
      "rightClick": _vm.updateCostCenter
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.vehicle.costCenter'),
      "outlined": ""
    },
    model: {
      value: _vm.costCenter,
      callback: function callback($$v) {
        _vm.costCenter = $$v;
      },
      expression: "costCenter"
    }
  })], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "1"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.invoice.invoiceInboundCount'),
      "type": "number",
      "dense": "",
      "readonly": "",
      "hide-details": "",
      "reverse": !_vm.isMobile
    },
    model: {
      value: _vm.inbound.length,
      callback: function callback($$v) {
        _vm.$set(_vm.inbound, "length", $$v);
      },
      expression: "inbound.length"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "1"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.invoice.invoiceOutboundCount'),
      "type": "number",
      "dense": "",
      "readonly": "",
      "hide-details": "",
      "reverse": !_vm.isMobile
    },
    model: {
      value: _vm.outbound.length,
      callback: function callback($$v) {
        _vm.$set(_vm.outbound, "length", $$v);
      },
      expression: "outbound.length"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.invoice.revenue'),
      "value": _vm.formatCurrency(_vm.outboundSubTotalSum, _vm.CurrencyEnum.EUR),
      "dense": "",
      "readonly": "",
      "hide-details": "",
      "reverse": !_vm.isMobile
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.invoice.expense'),
      "value": _vm.formatCurrency(_vm.inboundSubTotalSum, _vm.CurrencyEnum.EUR),
      "dense": "",
      "readonly": "",
      "hide-details": "",
      "reverse": !_vm.isMobile
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('components.PartnerReportDetail.invoice.balance'),
      "value": _vm.formatCurrency(_vm.subTotalDiff, _vm.CurrencyEnum.EUR),
      "dense": "",
      "readonly": "",
      "hide-details": "",
      "reverse": !_vm.isMobile,
      "append-icon": _vm.subTotalDiff < 0 ? 'mdi-alert-circle-outline' : '',
      "color": _vm.subTotalDiff < 0 ? 'error' : ''
    }
  })], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('v-tabs', {
    staticClass: "fill-height",
    attrs: {
      "vertical": !_vm.isMobile,
      "background-color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _c('v-tab', [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-invoice-text-outline")]), _vm._v(" " + _vm._s(_vm.$t("nav.INVOICE_TABLE.title")) + " ")], 1), _c('v-tab', [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-invoice-text-arrow-left-outline")]), _vm._v(" " + _vm._s(_vm.$t("nav.INVOICE_INBOUND_TABLE.title")) + " ")], 1), _c('v-tab', [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-invoice-text-arrow-right-outline")]), _vm._v(" " + _vm._s(_vm.$t("nav.INVOICE_OUTBOUND_TABLE.title")) + " ")], 1), _c('v-tab-item', [_c('invoice-table', {
    ref: "invoiceTable",
    attrs: {
      "partnerId": _vm.partner.id,
      "reportId": _vm.report.id,
      "vehicleId": _vm.report.vehicleId,
      "fleetId": _vm.report.fleetId
    }
  })], 1), _c('v-tab-item', [_c('invoice-inbound-table', {
    ref: "invoiceTable",
    attrs: {
      "partnerId": _vm.partner.id,
      "reportId": _vm.report.id,
      "vehicleId": _vm.report.vehicleId,
      "fleetId": _vm.report.fleetId
    }
  })], 1), _c('v-tab-item', [_c('invoice-outbound-table', {
    ref: "invoiceTable",
    attrs: {
      "partnerId": _vm.partner.id,
      "reportId": _vm.report.id,
      "vehicleId": _vm.report.vehicleId,
      "fleetId": _vm.report.fleetId
    }
  })], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }